// extracted by css-extract-rspack-plugin
export default {"header":"header-CxeHqQ","brand":"brand-_9Q8XQ","mode":"mode-mVf_Gl","actions":"actions-lKMeA8"};